module.exports = __webpack_public_path__ + "img/map-citationCJ2.a6bfc1b7.gif";